import { AuthGuard } from '../../shared/guards/AuthGuard';
import { AnalysisDetailPresentation } from './components/AnalysisDetailPresentation';
import { Sidebar } from '../../shared/components';

export const AnalysisDetailPage = (): JSX.Element => {
    return (
        <AuthGuard>
            <Sidebar>
                <AnalysisDetailPresentation />
            </Sidebar>
        </AuthGuard>
    )
};